import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { getApplicationSettings } from "owa-application-settings";

/**
 * Whether or not the mailbox supports shortcuts that can apply a specific
 * category to an item.
 */
export const categorizeShortcutsCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
    // Capability is only available in the native client
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return getApplicationSettings("PlatformType").isMonarch;
    },
};
